export default function TobaccoUse() {
    return [
        { label: "Currently use", value: "true" },
        { label: "Never used", value: "false" },
    ]
};


// WEBPACK FOOTER //
// ./src/components/Helpers/Lists/TobaccoUse.js